<template>
<DxValidationGroup ref="validationGroup">
   <div class="login row row_jsc row_ac">
		<div class="login_box">
			<div class="txt">
				<p>{{userNm}} <span>님</span> 비밀번호를 변경해 주세요.</p>
			</div>

			<!-- 인증요청 -->

        <div class="confirm" >
          <div class="number">
            <DxTextBox name="현재 비밀번호" :placeholder="formatMessage('nowPassword')" v-model="form.curentPassword" mode="password">
              <DxValidator>
                <DxRequiredRule :message="formatMessage('pwdMsg')"/>
              </DxValidator>
            </DxTextBox>
          </div>
          <div class="number">
            <DxTextBox name="변경 비밀번호" :placeholder="formatMessage('changePassword')" v-model="form.updatePassword" mode="password">
              <DxValidator>
                <DxPatternRule
                  :pattern="pwdPattern"
                  :message="formatMessage('pwdPattern')"
                />
                <DxStringLengthRule
                  :min="8"
                  :max="20"
                  :message="formatMessage('stringLen')"
                />
                <DxRequiredRule :message="formatMessage('pwdMsg')"/>
              </DxValidator>
            </DxTextBox>
          </div>
          <div class="number">
            <DxTextBox name="확인 비밀번호" :placeholder="formatMessage('confirmationPassword')" v-model="form.confirmPassword" mode="password">
              <DxValidator>
                <DxRequiredRule :message="formatMessage('rePwdMsg')"/>
                <DxCompareRule
                  :comparison-target="passwordComparison"
                  :message="formatMessage('checkRePwdMsg')"
                />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>
			<button type="button" class="login_btn" @click="updatePassword">확인</button>
		</div>
	</div>
</DxValidationGroup>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import {locale, loadMessages, formatMessage } from 'devextreme/localization'
import DxTextBox from 'devextreme-vue/text-box'
import DxValidationGroup from 'devextreme-vue/validation-group'
import {
  DxValidator,
  DxRequiredRule,
  DxCompareRule,
  DxEmailRule,
  DxPatternRule,
  DxStringLengthRule,
  DxRangeRule
} from 'devextreme-vue/validator'

export default {
  name: 'password',
  components: {
    DxValidationGroup,
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxEmailRule,
    DxPatternRule,
    DxStringLengthRule,
    DxRangeRule,
    DxTextBox
  },
  data: () => ({
    form: {
      curentPassword: '',
      updatePassword: '',
      confirmPassword: '',
      loginId : ''
    },
    pwdPattern: /^.*(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&]).*$/
  }),
  computed: {
    // 사용자 이름
    userNm () {
      return window.$store.getters['Login/getUserNm']
    }
  },
  methods: {
    formatMessage: formatMessage,
    updatePassword () {
      if (this.$refs['validationGroup'].instance.validate().isValid) {

        this.form.loginId = window.$store.getters['Login/getUserId'];

      Vue.httpClient
        .post('/app/login/password/update', this.form)
        .then( async (response) => {
          if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
            await Vue.Alert.alert(formatMessage('pwdChangMsg'));
            
            this.$router.push({name: 'home'})
          }
        }).catch( e => {
          console.log('결과상태값========='+e.result.status)
          if(e.result.status == AppConfig.PWD_UPDATE_FAIL){
            
            Vue.Alert.alert(formatMessage('pwdUpdateFailMsg')); 
          
          }else{
            
            Vue.Alert.alert(formatMessage('pwdComparisonMsg'));
          
          }
        }
        )             

      };
    },
    passwordComparison () {
      return this.form.updatePassword
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Password.vue